export default (theme) => ({
  dialogRoot: {
    [theme.breakpoints.up('sm')]: {
      width: 420,
    },
    [theme.breakpoints.down('sm')]: {
      margin: 5,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 20px 10px',
  },
  closeButton: {
    position: 'absolute',
    right: 15,
    top: 12,
    color: theme.palette.textColor.dark,
    padding: 5,
    '&:hover': {
      backgroundColor: '#fff !important',
      color: `${theme.palette.textColor.dark} !important`,
    },
  },
  content: {
    padding: '8px 24px 16px',
    color: theme.palette.textColor.dark,
    fontSize: 14,
    fontWeight: 500,
  },
  selector: {
    width: '100%',
    marginTop: 12,
    '& .MuiSelect-root': {
      color: '#777',
      fontWeight: 500,
      fontSize: 14,
      padding: '10px 16px',
    },
    '& .MuiSelect-icon': {
      right: 4,
    },
  },
  actions: {
    padding: '8px 24px 20px',
    justifyContent: 'center',
  },
  publishBtn: {
    color: '#fff',
    minWidth: 120,
    textTransform: 'capitalize',
    background: theme.palette.error.red,
    '&:hover': {
      color: '#fff',
      background: `${theme.palette.error.main} !important`,
    },
    '&:focus': {
      color: '#fff',
      background: `${theme.palette.error.red} !important`,
    },
  },
});
